exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".work-time {\r\n  width: 50px;\r\n}\r\n\r\n.history-header {\r\n  cursor: pointer;\r\n}\r\n\r\n.row {\r\n  -webkit-box-align: baseline;\r\n      -ms-flex-align: baseline;\r\n          align-items: baseline;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/interviews/questionnaires/candidate-qualification-questionnaire/candidate-qualification-questionnaire.component.css
// module id = ../../../../../src/app/interviews/questionnaires/candidate-qualification-questionnaire/candidate-qualification-questionnaire.component.css
// module chunks = main